import { Link } from "react-router-dom";
import type { Special } from "@/types/content";

interface SpecialPicksProps {
  specials: Special[];
}

export default function SpecialPicks({ specials }: SpecialPicksProps) {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
      {specials.map((sp) => (
        <Link
          key={sp.id}
          to={`/special?id=${sp.id}`}
          className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
        >
          <div className="relative h-48 w-full overflow-hidden bg-background-200">
            <img
              src={sp.cover}
              alt={`${sp.title}专题封面`}
              title={`${sp.title} - 激情视频专题`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-4">
              <span className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
                <i className="ri-bookmark-3-line" />
                精选专题
              </span>
              <h3 className="mt-2 text-lg font-bold text-background-50">{sp.title}</h3>
            </div>
          </div>
          <div className="p-4">
            <p className="text-sm font-medium text-foreground-800">{sp.subtitle}</p>
            <p className="mt-2 text-sm leading-relaxed text-foreground-500 line-clamp-2">{sp.reason}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
              查看专题
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}